export const paperProps = {
  PaperProps: {
    sx: {
      backgroundColor: '#FFF !important', // TODO clean up hex codes
      color: '#000 !important', // TODO clean up hex codes
      maxHeight: '300px',
      '.base-Popper-root': {
        backgroundColor: '#FFF !important', // TODO clean up hex codes
      },
    },
  },
};

export const boxStyles = { minWidth: '120px', width: '100%', display: 'flex', justifyContent: 'center' };
